import { ArrowDown } from '../../../../../components/svg'
import {
  Name,
  Color,
  Items,
  Label,
  Legend,
  TableTd,
  TableTh,
  Wrapper,
  Capacity,
  ListFlex,
  Quantity,
  Container,
  TableHead,
  VesselName,
  LegendItem,
  StyledTable,
  HeaderContent,
  ListContainer,
  ContainerTable,
  TableContainer,
  AccordionButton,
  QuantityContainer,
  ContainerEquipment,
} from '../../dashboard-jetty.styled'
import useHooks from './hooks'

const RightTable = ({ data, metadata }) => {
  const { data: hooksData, methods } = useHooks({ data })
  return (
    <Wrapper>
      <Container>
        <QuantityContainer>
          <Quantity left>
            <span>TARGET (THIS MONTH)</span>
            <span>{metadata?.target || 0}</span>
          </Quantity>
          <Quantity right>
            <span>ACTUAL (MTD)</span>
            <span>{metadata?.actual || 0}</span>
          </Quantity>
        </QuantityContainer>
        {hooksData?.jettyData?.map((item, index) => (
          <TableContainer key={index}>
            <HeaderContent>
              <VesselName>{item?.detailTable?.Vessel_Name}</VesselName>
              <AccordionButton
                type='button'
                open={hooksData.selectedEquipment.includes(index)}
                onClick={methods.handleClickAccordion(index)}
              >
                <ArrowDown />
              </AccordionButton>
            </HeaderContent>
            {hooksData.selectedEquipment.includes(index) && (
              <>
                <ContainerTable>
                  <StyledTable>
                    <TableHead>
                      <tr>
                        <TableTh>Jetty</TableTh>
                        <TableTh>S/Plan</TableTh>
                        <TableTh>Actual qty</TableTh>
                        <TableTh>Balance</TableTh>
                      </tr>
                    </TableHead>
                    <tbody>
                      <tr>
                        <TableTd>{item.detailTable?.Jetty_Name}</TableTd>
                        <TableTd>{item.detailTable?.Stowage_Plan}</TableTd>
                        <TableTd>{item.detailTable?.Actual}</TableTd>
                        <TableTd>{item.detailTable?.Balance}</TableTd>
                      </tr>
                    </tbody>
                  </StyledTable>
                </ContainerTable>
                {hooksData.JETTY_LIST.includes(item.detailTable?.Jetty_Name) && (
                  <ContainerEquipment>
                    <ListContainer>
                      <Label>Barge List</Label>
                      {item.detailTable?.Barge?.map((barge, index) => (
                        <ListFlex key={index}>
                          <Items>
                            <Color color={barge.Color_Status?.toLowerCase()} />
                            <Name>{barge.Name}</Name>
                          </Items>
                          <Capacity>
                            {barge.Weight} {barge.UOM}
                          </Capacity>
                        </ListFlex>
                      ))}
                    </ListContainer>
                    <ListContainer>
                      <Label>Crane List</Label>
                      {item.detailTable?.Crane?.map((barge, index) => (
                        <ListFlex key={index}>
                          <Items>
                            <Color color={barge.Color_Status?.toLowerCase()} />
                            <Name>{barge.Name}</Name>
                          </Items>
                          <Capacity>
                            {barge.Weight} {barge.UOM}
                          </Capacity>
                        </ListFlex>
                      ))}
                    </ListContainer>
                  </ContainerEquipment>
                )}
              </>
            )}
          </TableContainer>
        ))}
      </Container>
      <Legend>
        <LegendItem>
          <Color color='green' />
          Completed
        </LegendItem>
        <LegendItem>
          <Color color='orange' />
          Alongside MV
        </LegendItem>
        <LegendItem>
          <Color color='gray' />
          Queued
        </LegendItem>
      </Legend>
    </Wrapper>
  )
}

export default RightTable
